import type { SelectMenuItem } from '@nuxt/ui'

export const useSelectInputAdapter = <T extends object>(items: MaybeRef<T[] | null | undefined>, {
    value,
    label,
}: { value: keyof T; label: keyof T }) => computed(() => unref(items)?.map(item => ({
        value: item[value],
        label: item[label],
    } as SelectMenuItem))) ?? []
